import { isBoolean } from 'lodash';

// oxlint-disable-next-line typescript/no-explicit-any
export function couldBeBoolean(v?: any): v is boolean | 'true' | 'false' | '0' | '1' {
  return isBoolean(v) || v === 'true' || v === 'false' || v === '0' || v === '1';
}
